import fonts from 'styles/fonts';
import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
};

const TextHeading = styled('div')<Props>({
  fontSize: fonts.size['16'],
  paddingTop: '1.2rem',
});

export default TextHeading;
